export default "__VITE_ASSET__BUtdJtbS__"